import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@tillersystems/stardust';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';

import { OrderList, Page } from '../../components';
import * as NavActions from '../../services/NavigationService/actions';
import * as SFActions from '../../services/DataServices/SFDataService/actions';

const { func, object } = PropTypes;

/**
 * Order age
 *
 * This component is in charge of displaying
 * a the order page
 *
 * @return {jsx}
 */

export class Order extends Component {
  state = {
    stageValue: 'Page 3',
    stageNumber: 3,
  };
  /**
   * PropTypes validation
   */
  static propTypes = {
    opportunity: object.isRequired,
    actions: object.isRequired,
    customerQuotation: object.isRequired,
    t: func.isRequired,
  };

  componentDidMount() {
    const { opportunity, actions } = this.props;
    const { stageValue, stageNumber } = this.state;

    if (opportunity._stageValue !== null) {
      actions.opportunityNeedUpdate(opportunity.getId(), stageValue, stageNumber);
    }
    actions.setCurrentStep(2);
  }

  render() {
    const { customerQuotation, t } = this.props;
    const orderList = customerQuotation._products.map(data => (
      <OrderList.Item key={`${data.quantity}-${data.name}`}>
        {`${data.quantity} x ${data.name}`}
      </OrderList.Item>
    ));

    return (
      <Page>
        <Page.Title>{t('orderPage.heading')}</Page.Title>
        <Page.Paragraph>{t('orderPage.content')}</Page.Paragraph>
        <OrderList>
          <OrderList.Title>{t('orderPage.heading2')}</OrderList.Title>
          {customerQuotation._products.length > 0 ? (
            orderList
          ) : (
            <OrderList.Item>{t('orderPage.noProductsToShow')}</OrderList.Item>
          )}
        </OrderList>
        <Link to="/delivery">
          <Button big primary fluid>
            {t('orderPage.button')}
          </Button>
        </Link>
      </Page>
    );
  }
}

/**
 * Action creators does our component
 * want to receive by props
 */
// const mapDispatchToProps = dispatch => ({
// actions: bindActionCreators(Actions, dispatch),
// });
const mapStateToProps = state => ({
  customerQuotation: state.customerQuotation,
  opportunity: state.opportunity,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      ...NavActions,
      opportunityNeedUpdate: SFActions.opportunityNeedUpdate,
    },
    dispatch,
  ),
});

const OrderConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Order);

export default translate('translations')(OrderConnect);



// WEBPACK FOOTER //
// ./src/pages/Order/index.js